import { render, staticRenderFns } from "./AdminUserManagement.page.vue?vue&type=template&id=ba670c90"
import script from "./AdminUserManagement.page.vue?vue&type=script&lang=ts"
export * from "./AdminUserManagement.page.vue?vue&type=script&lang=ts"
import style0 from "./AdminUserManagement.page.vue?vue&type=style&index=0&id=ba670c90&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports